module.exports = __webpack_public_path__ + "img/FOTON.b4e45ccd.svg";